// Main Login Component - Super Admin and User Authentication
import React, { useState } from 'react';
import { authService } from '../../services/authService.js';

const MainLoginComponent = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const result = await authService.login(username, password);
            if (result.success) {
                onLoginSuccess(result.user);
                return;
            }
            throw new Error('Invalid username or password');
        } catch (error) {
            console.error('Login error:', error);
            setError(error.message || 'Invalid username or password');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url("https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        }}>
            <div style={{
                background: 'rgba(255, 255, 255, 0.95)',
                padding: '50px',
                border: '2px solid #1e293b',
                width: '100%',
                maxWidth: '450px',
                boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
            }}>
                <div style={{
                    textAlign: 'center',
                    marginBottom: '40px',
                    borderBottom: '2px solid #1e293b',
                    paddingBottom: '20px'
                }}>
                    <h2 style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        color: '#1e293b',
                        margin: '0 0 10px 0',
                        letterSpacing: '1px'
                    }}>CRM ACCESS</h2>
                    <p style={{
                        margin: '0',
                        color: '#666666',
                        fontSize: '14px',
                        textTransform: 'uppercase',
                        letterSpacing: '2px'
                    }}>User Authentication</p>
                </div>

                <form onSubmit={handleLogin} style={{ marginBottom: '0' }}>
                    {error && (
                        <div style={{
                            background: '#1e293b',
                            color: '#ffffff',
                            padding: '12px',
                            marginBottom: '20px',
                            border: '1px solid #1e293b',
                            fontSize: '14px'
                        }}>
                            {error}
                        </div>
                    )}

                    <div style={{ marginBottom: '25px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#1e293b',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>
                            Username
                        </label>
                        <input
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter your username"
                            required
                            disabled={isLoading}
                            autoComplete="username"
                            style={{
                                width: '100%',
                                padding: '12px',
                                border: '2px solid #1e293b',
                                fontSize: '14px',
                                background: '#ffffff',
                                color: '#1e293b',
                                boxSizing: 'border-box',
                                outline: 'none',
                                fontFamily: 'inherit'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#1e293b'}
                            onBlur={(e) => e.target.style.borderColor = '#1e293b'}
                        />
                    </div>

                    <div style={{ marginBottom: '30px' }}>
                        <label style={{
                            display: 'block',
                            marginBottom: '8px',
                            fontSize: '12px',
                            fontWeight: '600',
                            color: '#1e293b',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>
                            Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                            disabled={isLoading}
                            autoComplete="current-password"
                            style={{
                                width: '100%',
                                padding: '12px',
                                border: '2px solid #1e293b',
                                fontSize: '14px',
                                background: '#ffffff',
                                color: '#1e293b',
                                boxSizing: 'border-box',
                                outline: 'none',
                                fontFamily: 'inherit'
                            }}
                            onFocus={(e) => e.target.style.borderColor = '#1e293b'}
                            onBlur={(e) => e.target.style.borderColor = '#1e293b'}
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={isLoading}
                        style={{
                            width: '100%',
                            padding: '14px',
                            background: '#1e293b',
                            color: '#ffffff',
                            border: '2px solid #1e293b',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: isLoading ? 'not-allowed' : 'pointer',
                            textTransform: 'uppercase',
                            letterSpacing: '2px',
                            marginBottom: '15px',
                            transition: 'all 0.3s'
                        }}
                        onMouseOver={(e) => {
                            if (!isLoading) {
                                e.target.style.background = '#ffffff';
                                e.target.style.color = '#1e293b';
                            }
                        }}
                        onMouseOut={(e) => {
                            e.target.style.background = '#1e293b';
                            e.target.style.color = '#ffffff';
                        }}
                    >
                        {isLoading ? 'Authenticating...' : 'Login'}
                    </button>
                </form>

                <div style={{
                    marginTop: '30px',
                    paddingTop: '20px',
                    borderTop: '1px solid #cccccc',
                    textAlign: 'center'
                }}>
                    <p style={{
                        margin: '0',
                        fontSize: '11px',
                        color: '#999999',
                        textTransform: 'uppercase',
                        letterSpacing: '1px'
                    }}>CRM System v2.0 - Professional Access</p>
                </div>
            </div>
        </div>
    );
};

export default MainLoginComponent;
